import React from "react";
import { Box, Chip, Typography } from "@mui/material";

const BRAND_BLUE = "#00336C";
const BRAND_GREEN = "#648315";

const SUGGESTED_QUESTIONS = [
  "How do I add a prospect?",
  "How do I use AI company lookup?",
  "How do I create a trade show workspace?",
  "How do I update a BRE company?",
  "How do I add exhibitors to a trade show?",
];

export default function SuggestedHelpQuestions({ onSelect, disabled }) {
  return (
    <Box sx={{ mt: 1.25 }}>
      <Typography sx={{ color: "#58708a", fontSize: "0.78rem", fontWeight: 800, mb: 0.75 }}>
        Suggested questions
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
        {SUGGESTED_QUESTIONS.map((question) => (
          <Chip
            key={question}
            label={question}
            onClick={() => onSelect(question)}
            disabled={disabled}
            sx={{
              maxWidth: "100%",
              color: BRAND_BLUE,
              borderColor: "rgba(0,51,108,0.2)",
              backgroundColor: "#fff",
              fontWeight: 800,
              "&:hover": {
                color: "#fff",
                backgroundColor: BRAND_GREEN,
              },
            }}
            variant="outlined"
          />
        ))}
      </Box>
    </Box>
  );
}
